import * as yup from 'yup';

const schema = yup.object().shape({
  countryId: yup.string().required(),
  marginWholesaler: yup.number().required(),
  marginDistributor: yup.number().required(),
  marginRetailer: yup.number().required(),
  vat: yup.number().required(),
});

export default schema;
